import { Layout } from 'antd';
import React from 'react';
import Sidebar from '../components/Sidebar/Sidebar';
import Navbar from '../components/Navbar/Navbar';
import FooterComponent from '../components/Footer/Footer';
import Banner from '../components/Banner/Banner';
import { Outlet } from 'react-router-dom';
import "./Layout.scss";

const { Content, Footer } = Layout;

const DashboardLayout = () => {
    return (
        <Layout className='layout'>
            <Sidebar />
            <Layout>
                <Navbar />
                <Banner/>
                <Content className='dashboard-content'>
                    <Outlet />
                </Content>
                <Footer className='footer'>
                    <FooterComponent />
                </Footer>
            </Layout>
        </Layout>
    );
};

export default DashboardLayout;
